module.exports = __webpack_public_path__ + "img/abstract-planes.038f51be.svg";